<template>
	<div class="video-modal__container" ref="container">
		<button class="video-modal__close-btn" @click.prevent="closeModal()">
			Return
		</button>
		<VideoJs :videoServer="video.src" :autoplay="true" :cc="video.cc" />
	</div>
</template>

<script>

	import VideoJs from "@/components/VideoJs"

	export default {
		name: "videoModal",
		components: { VideoJs },
		methods: {
			closeModal () {
				this.$store.commit('app/setActiveVideoModal', false)
			}
		},
		computed: {
			video () {
				return this.$store.state.app.activeVideoModal
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import "media.scss";
	@import "button-reset";
	@import "responsive-font";
	@import "fade-transition";

	.video-modal {

		&__container {
			display:flex; position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 100; background-color: black;
		}

		&__content {
			width:100%; height:auto;
		}

		&__close-btn {
			@include button-reset;
			@include responsive-font(15);
			position: fixed; top: 2rem; left: 2rem; z-index: 101; color: #fff; line-height: 1; outline: none; text-transform: uppercase; font-weight: 500; cursor:pointer;

			&::before {
				content: "\27E8"; color: #ffb500; position: relative; top: -1px; margin-right: .75rem; font-weight: 700;
			}

			&:hover {
				color: #ffb500;
			}

		}

	}

	@include fade-transition(.3s);
</style>



// WEBPACK FOOTER //
// src/components/VideoModal/index.vue